var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p3"},[_c('p',{staticClass:"h4 bold darkblue line-height-2 my3"},[_vm._v("Version")]),_vm._v(" "),_vm._l((_vm.versionData),function(version,index){return _c('p',{key:index},[_c('span',{staticClass:"bold caps"},[_vm._v(_vm._s(index))]),_vm._v(": "+_vm._s(version))])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d7caecf","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/portal/version.vue
// module id = 1603
// module chunks = 4